import React from 'react';
import about_1 from "../../asset/about_1.jpg";
import about_2 from "../../asset/about_2.jpg";
const About = () => {
  return (
    <section id="about" className="container mb-5 about-page">
        
        <h2 className="heading">About Us</h2>
        {/* <h5>Thematic work area - Education  </h5> */}
        <div>
            <p>
                 Janpravaha Social Foundation as the name suggests, it makes an effort to understand the
                needs of the different segments of society & work as facilitator for mainstreaming the
                unacknowledged sector of society.
            </p>
            <p>
                It’s a non-profit organization in Maharashtra working in
                the field of education, development initiatives, infrastructure equipping, health care
                management, skill development & enhancement activities, environment sustenance activities,
                rural development, rehabilitation etc. towards the betterment of individuals.
            </p>
            <p>
               Since the
                organization being novice, we are working at different levels and are keen on opening new
                opportunities. This will definitely help us to plant and strengthen our roots in social welfare
                activities.
            </p>
            <p>
               We do feel that individuals have their own competencies, it is more of giving
                exposure and thus our team works with the approach of enrichment. Thus, the ideology of our
                organization works for individuals to be more self-reliant.
            </p>
        </div> 

        <hr />
        <div>
                <h4>
                    At Janpravaha Social Foundation, we believe that youth voices shape the future. 🌱
                </h4>
                <p>
                    We recently collaborated with enthusiastic interns from Wadia College (SYBBA) who worked dedicatedly on a meaningful project focused on understanding the impact of social media on youth.
                </p>
                <p>
                     As part of this initiative:
                    <p>* Interns designed and created Google Forms</p>
                    <p>* Conducted surveys among young individuals</p>
                    <p>* Collected valuable insights on social media usage, behavior & its influence</p>
                </p>
                <p>
                    Their efforts helped us gather important ground-level perspectives that will contribute to future awareness and action-driven initiatives.
                </p>
                <p>
                    A big appreciation to all the interns for their commitment, creativity, and teamwork throughout the project!
                </p>
                <p>
                    Together, we continue to create awareness, inspire change, and empower communities.
                </p>
                <img src={about_1} class="about_img" />
                <img src={about_2} class="about_img" />
        </div> 
    </section>
  );
};

export default About;
